var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    width: 32,
    height: 32,
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.5 35.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.93,
    cy: 15.98,
    r: 12.43
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.68,35.45H14.87c-.45,0-.82-.37-.82-.82V14.82c0-.45.37-.82.82-.82h19.82c.45,0,.82.37.82.82v19.82c0,.45-.37.82-.82.82ZM15.67,33.83h18.19V15.63H15.67v18.19h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8 0 0 0 0 8 8 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/Shape.6a97ec5d701ee1481fcc4809c9093fea.svg";
export { ForwardRef as ReactComponent };